module.exports = __webpack_public_path__ + "static/media/enertech.e63fd74f.png";